import React from "react";
import { LawIcon, UserIcon } from "./Icons.tsx";

interface ChatAvatarProps {
  isAi: boolean;
}

export const ChatAvatar: React.FC<ChatAvatarProps> = ({ isAi }) => {
  return (
    <div className={`shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-2xl flex items-center justify-center transition-all group-hover:scale-105 shadow-sm border ${
      isAi
        ? "glass-panel text-blue-600 dark:text-blue-400"
        : "bg-blue-600 text-white border-blue-500 shadow-blue-500/20"
    }`}
    >
      {isAi ? <LawIcon /> : <UserIcon />}
    </div>
  );
};
